import carousel from '@/js/util/symbols/carousel'

export default {
  inject: { carousel },
  props: {
    direction: {
      type: String,
      required: true,
      validator: direction => ['next', 'previous'].includes(direction),
    },
  },

  mounted() {
    this.showButtons()
    window.addEventListener('resize', this.showButtons)
    // set active button when slides are changed through other means
    this.carousel.$on('carousel:scroll:auto', this.setActive)
    this.carousel.$on('set:item', this.setActive)
  },

  methods: {
    setsCarouselDirection(direction) {
      this.carousel.$emit('carousel:direction', direction)
      this.setActive()
    },
    handleKeyUpevent(event) {
      this.carousel.$el.setAttribute('aria-live', true)
      const { direction } = this
      const eventToEmit = {
        ArrowLeft: direction,
        ArrowRight: direction,
      }[event.key]

      if (!eventToEmit) {
        return
      }

      event.preventDefault()
      this.setsCarouselDirection(eventToEmit)
    },

    removeLive() {
      this.carousel.$el.removeAttribute('aria-live')
    },

    showButtons() {
      if (this.carousel.$el.childNodes[4].childNodes[2]) {
        if (
          this.carousel.$el.childNodes[4].childNodes[2].clientWidth >
          window.innerWidth
        ) {
          this.$el.style.display = 'block'
        } else if (
          this.carousel.$el.childNodes[4].childNodes[2].clientWidth <=
          window.innerWidth
        ) {
          this.$el.style.display = 'none'
        }
      }
      this.setActive()
    },

    setActive() {
      if (this.direction === 'previous') {
        if (
          this.carousel._data.currentItem !==
          this.carousel.items[this.carousel.items.length - 1]
        ) {
          this.$el.parentElement.nextSibling.nextSibling.firstChild.classList.remove(
            'inactive'
          )
          this.$el.parentElement.nextSibling.nextSibling.firstChild.tabIndex = 0
        }
        if (this.carousel._data.currentItem === this.carousel.items[0]) {
          this.$el.classList.add('inactive')
          this.$el.tabIndex = -1
        }
      } else if (this.direction === 'next') {
        if (this.carousel._data.currentItem !== this.carousel.items[0]) {
          this.$el.parentElement.previousSibling.previousSibling.firstChild.classList.remove(
            'inactive'
          )
          this.$el.parentElement.previousSibling.previousSibling.firstChild.tabIndex = 0
        }
        if (
          this.carousel._data.currentItem ===
          this.carousel.items[
            this.carousel.items.length -
              Math.floor(
                window.innerWidth /
                  this.carousel._data.currentItem.$el.offsetWidth
              ) +
              1
          ]
        ) {
          this.$el.classList.add('inactive')
          this.$el.tabIndex = -1
        }
      }
    },
  },
  render(createElement) {
    const elementData = {
      on: {
        keyup: this.handleKeyUpevent,
        blur: this.removeLive,
        click: () => this.setsCarouselDirection(this.direction),
      },
    }

    return createElement('button', elementData, this.$slots.default)
  },
}
